import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  const scrollToProducts = () => {
    const productsSection = document.getElementById('produtos');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contato');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Modern%20vertical%20construction%20site%20with%20tower%20cranes%20and%20construction%20elevators%20against%20clear%20sky%20industrial%20equipment%20machinery%20steel%20structures%20concrete%20buildings%20under%20construction%20professional%20photography%20wide%20angle%20view%20daytime%20lighting%20sharp%20details%20construction%20industry%20urban%20development%20high%20rise%20building%20site&width=1920&height=1080&seq=hero-construction-bg-001&orientation=landscape)'
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 px-6 sm:px-12 md:px-20 max-w-4xl w-full py-24 sm:py-0">
        {/* Logo */}
        <div className="mb-6 sm:mb-8">
          <img 
            src="https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/3dcdbb178e5fb905220d9ae2fca35ce8.png" 
            alt="Moviis Logo" 
            className="h-8 sm:h-12 brightness-0 invert"
          />
        </div>

        <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white mb-8 sm:mb-10 leading-tight">
          {t('hero_title')}
        </h1>
        
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 items-start">
          <button 
            onClick={scrollToProducts}
            className="w-full sm:w-auto px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer text-center"
          >
            {t('hero_view_products')}
          </button>
          <button 
            onClick={scrollToContact}
            className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-gray-900 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer text-center"
          >
            {t('hero_request_quote')}
          </button>
        </div>
      </div>

    </section>
  );
}